import React,{useState} from "react";
import "../Assets/Styles.css";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {db} from '../Components/firebase'
const vertical='top';
const horizontal='right';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Contact() {
    const [ContactForm, setContactForm] = useState({Name:"",EMail:"",Subject:"",Message:""})
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
      setOpen(true);
    };
  
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setOpen(false);
    };
    const HandleTextChange=(Value,Field)=>{
        setContactForm({...ContactForm,[Field]:Value});
        console.log(ContactForm);
    }
    const SubmitForm=()=>{
        db.collection("NewContact").doc(ContactForm.EMail+Date.now()).set({
            Name: ContactForm.Name,
            Email: ContactForm.EMail,
            Subject: ContactForm.Subject,
            Message:ContactForm.Message
        })
        .then(() => {
          handleClick();
            console.log("Document successfully written!");
            document.getElementById("ContactForm").reset();
        })
        .catch((error) => {
            console.error("Error writing document: ", error);
        });

        setContactForm({Name:"",EMail:"",Subject:"",Message:""});
    }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        paddingRight:'30px'
      }}
    >
      <div>
        <Typography variant="h2" component="h2" gutterBottom className="Header">
          CONTACT ME
        </Typography>
        <Divider />
      </div>
      <div
        style={{
          border: "solid white 1px",
          width: "auto",
          height: "50%",
          margin: "auto",
          borderRadius: "10px",
          padding: "10px",
          marginTop: "10px",
        }}
      >
        <form  id="ContactForm">
          <TextField
            id="name"
            label="Name"
            fullWidth
            autoFocus={true}
            margin="normal"
            color="secondary"
            onChange={(event)=>{HandleTextChange(event.target.value,"Name")}}
          />
          <TextField
            id="email"
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            color="secondary"
            onChange={(event)=>{HandleTextChange(event.target.value,"EMail")}}
          />
          <TextField
            id="FormSubject"
            label="Subject"
            fullWidth
            margin="normal"
            color="secondary"
            onChange={(event)=>{HandleTextChange(event.target.value,"Subject")}}
          />
          <TextField
            id="FormMessage"
            label="Message"
            multiline={true}
            fullWidth
            margin="normal"
            minRows={4}
            color="secondary"
            onChange={(event)=>{HandleTextChange(event.target.value,"Message")}}
          />
          <div style={{ marginTop: "10px" }} />
          <Button variant="outlined" color="secondary" fullWidth={true} onClick={SubmitForm}>
            SUBMIT
          </Button>
        </form>
      </div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}   anchorOrigin={{ vertical, horizontal }}>
        <Alert onClose={handleClose} severity="success">
          Form submitted successfully
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Contact;
